module.exports = __webpack_public_path__ + "img/article-gb-dwrg-7.352c17bc.jpg";